import moment from "moment";

export const formatDate = (date: Date): string =>
  moment(date).format("DD/MM/YYYY");

export const composeDateRange = (start: Date, end: Date): string => {
  return `${formatDate(start)} - ${formatDate(end)}`;
};
